var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginOption3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.1344 11.6816C29.4119 19.2992 24.2704 26.5225 16.6528 27.8C15.3753 28.0208 14.0978 28.0524 12.8676 27.9262C8.8932 27.5161 5.2973 25.4028 2.99467 22.2169L25.6583 15.7191C25.9895 15.6245 25.8948 15.309 25.6267 15.3248L16.1165 15.9872C17.4571 14.6939 18.4822 13.1168 18.3561 10.9246C18.1037 7.37599 14.4921 3.90626 7.77343 1.63517C9.06668 0.956999 10.4861 0.452312 12.0002 0.199968C13.2777 -0.0208322 14.5552 -0.0523752 15.7853 0.0737965C21.8889 0.704655 27.0619 5.34147 28.1186 11.6816H28.1344ZM0.534322 16.3184C0.849752 18.211 1.5437 19.9458 2.50576 21.4757C6.11742 20.4663 9.28749 18.558 10.423 14.3154C11.669 9.64708 10.2495 4.74215 6.85868 2.15563C2.23764 5.08912 -0.427737 10.5934 0.534322 16.3184Z",
    fill: "#49494A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginOption3);
export default __webpack_public_path__ + "static/media/login-option-3.cdd734812dd4d3141ca6bb3bda2ce981.svg";
export { ForwardRef as ReactComponent };